export const SORT_TYPE = {
  AGE: 'age',
  QUANTITY: 'quantity',
};
